import { render, staticRenderFns } from "./UnderfloorHeating.vue?vue&type=template&id=1929b354&scoped=true&"
import script from "./UnderfloorHeating.vue?vue&type=script&lang=js&"
export * from "./UnderfloorHeating.vue?vue&type=script&lang=js&"
import style0 from "./UnderfloorHeating.vue?vue&type=style&index=0&id=1929b354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929b354",
  null
  
)

export default component.exports